<template>
  <div class="ov-page">
    <div class="ov-header">
      <div class="ov-note ov-note--info ov-header__note">
        <v-icon small>mdi-information-outline</v-icon>
        <span>{{ $t('verifyTicket.subtitle') }}</span>
      </div>
    </div>

    <div class="ov-grid">
      <!-- ===== RECHERCHE ===== -->
      <div class="ov-card">
        <div class="ov-card__head">
          <div class="ov-card__title">{{ $t('verifyTicket.searchByReference') }}</div>
        </div>

        <div class="ov-card__body">
          <div class="ov-field">
            <label class="ov-label" for="tk-reference">
              {{ $t('verifyTicket.ticketReference') }}<span class="ov-required">*</span>
            </label>
            <div class="ov-search tk-search">
              <v-icon small>mdi-ticket-confirmation-outline</v-icon>
              <input
                id="tk-reference"
                ref="referenceInput"
                v-model.trim="dataToSend.data.reference"
                type="text"
                class="ov-input"
                :placeholder="$t('verifyTicket.ticketReferencePlaceholder')"
                autocomplete="off"
                @keyup.enter="dataToSend.data.reference && checkTicketReservation()"
              />
            </div>
            <div class="ov-hint">{{ $t('verifyTicket.tip') }}</div>
          </div>
        </div>

        <div class="ov-card__foot">
          <button type="button" class="ov-btn ov-btn--secondary" @click="reinitForm">
            {{ $t('verifyTicket.reset') }}
          </button>
          <button
            type="button"
            class="ov-btn ov-btn--primary"
            :disabled="!dataToSend.data.reference || overlay"
            @click="checkTicketReservation"
          >
            <v-icon small>mdi-magnify</v-icon>
            {{ $t('verifyTicket.verifyTicket') }}
          </button>
        </div>
      </div>

      <!-- ===== DERNIER RÉSULTAT ===== -->
      <div class="ov-sticky">
        <div class="ov-card">
          <div class="ov-card__head">
            <div class="ov-card__title">{{ $t('verifyTicket.lastVerification') }}</div>
          </div>
          <div class="ov-card__body">
            <div v-if="!lastResult" class="ov-empty">{{ $t('verifyTicket.noVerification') }}</div>

            <template v-else>
              <div class="tk-result" :class="lastResult.validate === true ? 'tk-result--ok' : 'tk-result--ko'">
                <v-icon size="22">{{ lastResult.validate === true ? 'mdi-check-circle' : 'mdi-close-circle' }}</v-icon>
                <span>{{ lastResult.validate === true ? $t('verifyTicket.valid') : $t('verifyTicket.notValid') }}</span>
              </div>
              <div class="ov-stat">
                <span class="ov-stat__label">{{ $t('verifyTicket.reference') }}</span>
                <span class="ov-stat__value">{{ lastResult.reference || dataToSend.data.reference || '—' }}</span>
              </div>
              <div class="ov-stat">
                <span class="ov-stat__label">{{ $t('verifyTicket.message') }}</span>
                <span class="ov-stat__value tk-message">{{ lastResult.description || '—' }}</span>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <v-alert class="myalert alert-error" type="error" width="350px" dismissible>{{ errorMsg }}</v-alert>
    <v-overlay :value="overlay"><v-progress-circular indeterminate size="56" color="#159e72"></v-progress-circular></v-overlay>
  </div>
</template>

<script>
import axios from "axios";
import {
  API_CHECK_TICKET,
  HEADERS,
} from "@/components/globalConfig/globalConstConfig";
import { showErrorMessage } from "../messages/messageProcess";
export default {
  name: "VerifierBilletReservation",


  data() {
    return {
      overlay: false,
      errorMsg: null,
      lastResult: null,
      dataToSend: {
        data: {
          reference: null,
        },
      },
    };
  },

  methods: {
    reinitForm() {
      this.dataToSend.data.reference = null;
      this.lastResult = null;
      this.errorMsg = null;
    },

    // VÉRIFIER LA VALIDITÉ D'UN BILLET PAR SA RÉFÉRENCE
    async checkTicketReservation() {
      this.overlay = true;
      await axios
        .post(API_CHECK_TICKET, this.dataToSend, {
          headers: HEADERS(this.$store.state.userAuthentified.token),
        })
        .then((response) => {
          if (response.status == 200) {
            if (response.data.status.code == 800) {
              this.lastResult = response.data.item;
              if (response.data.item.validate == false) {
                this.$swal.fire(
                  this.$t('verifyTicket.verification'),
                  response.data.item.description,
                  "error"
                );
              } else {
                this.$swal.fire(
                  this.$t('verifyTicket.verification'),
                  response.data.item.description,
                  "success"
                );
              }
            } else {
              // Réponse sans billet : on l'indique au lieu de ne rien afficher
              this.$swal.fire(
                this.$t('verifyTicket.verification'),
                response.data.status.message,
                "error"
              );
            }
          } else {
            this.errorMsg = this.$t('verifyTicket.errorCreation');
            showErrorMessage();
          }
        })
        .catch((e) => {
          this.errorMsg = e;
          showErrorMessage();
        })
        .finally(() => {
          this.overlay = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/admin/ui";

.tk-search {
  min-width: 0;

  .ov-input {
    height: 48px;
    font-size: 15px;
    font-weight: 700;
    letter-spacing: 0.02em;
  }
}

.tk-result {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
  padding: 14px 16px;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 800;

  .v-icon {
    color: inherit !important;
  }

  &--ok {
    color: $ov-green-dark;
    background: rgba(21, 158, 114, 0.1);
  }

  &--ko {
    color: #dc2626;
    background: rgba(239, 68, 68, 0.1);
  }
}

.tk-message {
  font-weight: 600;
  color: $ov-muted;
}
</style>
